export class UpdateEdgeResponse {
    constructor() {
        this.edge_description = "";
        this.input_nodes = [];
    }
}
export class InputNode {
}
